<template>
  <div class="row statistique-page">
    <div class="col-12">
      <div class="row">
        <div class="col-4">
          <div class="card">
            <header class="card-header">Utilisateur(s) connecté(s)</header>
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <span class="btn btn-primary">{{ usersConnectedCount }}</span>
                <button
                  type="button"
                  class="btn btn-secondary btn-sm"
                  v-b-toggle="'list-user'"
                >
                  Details <font-awesome-icon :icon="['fas', 'caret-down']" />
                </button>
              </div>

              <b-collapse id="list-user" class="my-2">
                <b-card>
                  <ul>
                    <li v-for="user in usersConnected" :key="user">
                      {{ user }}
                    </li>
                  </ul>
                </b-card>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="card my-5">
        <header class="card-header">Filtre</header>
        <div class="card-body">
          <form class="">
            <!-- societe -->
            <div role="group" class="form-group">
              <label for="">Société</label>
              <div class="input-group">
                <multiselect
                  v-model="societeValue"
                  :options="societeOptions"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                >
                </multiselect>
              </div>
            </div>
            <!-- ./societe -->
            <!-- user -->
            <div role="group" class="form-group">
              <label for="">Utilisateurs</label>
              <div class="input-group">
                <multiselect
                  v-model="userValue"
                  :options="userOptions"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                >
                </multiselect>
              </div>
            </div>
            <!-- user -->
            <div role="group" class="form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">Date de début</span>
                </div>
                <b-form-datepicker
                  id="date-deb"
                  v-model="dateDebut"
                  :max="dateMax"
                  :hide-header="true"
                  calendar-width="300px"
                  :today-button="false"
                  :date-format-options="{
                    day: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                  }"
                  @input="handleChangeDateDeb"
                >
                </b-form-datepicker>
              </div>
            </div>
            <div role="group" class="form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">Date de fin</span>
                </div>
                <b-form-datepicker
                  id="date-fin"
                  v-model="dateFin"
                  :min="dateMinFin"
                  :max="dateMax"
                  :hide-header="true"
                  calendar-width="300px"
                  :today-button="false"
                  :date-format-options="{
                    day: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                  }"
                >
                </b-form-datepicker>
              </div>
            </div>
            <div class="form-actions text-right">
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                @click="resetFilter"
              >
                Effacer filtre
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="handleSubmitFilter"
              >
                Filtrer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-8">
      <div class="my-5">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" role="tab">
            Statistique fréquence de connexion
          </b-card-header>
          <b-card-body>
            <b-table striped hover :items="listItems"></b-table>
            <div class="no-result" v-if="noResult">Aucun resultat</div>
          </b-card-body>
        </b-card>
      </div>
      <div>
        <div class="result-wrapper">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab">
              Statistique quantité de projets créés
            </b-card-header>
            <b-card-body>
              <div v-for="societe in statCreatedProjectList" :key="societe.id">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button
                      block
                      class="d-flex justify-content-between"
                      v-b-toggle="'societe_' + societe.id"
                      variant="primary"
                      >{{ societe.nom }}
                      <span>total: {{ societe.nb_projet }}</span>
                    </b-button>
                  </b-card-header>
                  <b-collapse :id="'societe_' + societe.id" role="tabpanel">
                    <b-card-body>
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Utilisateur</th>
                            <th>Nombre de projet créé</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="user in societe.utilisateurs"
                            :key="user.id"
                          >
                            <td>{{ `${user.nom} ${user.prenom}` }}</td>
                            <td>{{ user.nb_projet }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
              <div class="no-result" v-if="noResultCreatedProject">
                Aucun resultat
              </div>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <!-- filtre -->
        <div class="col-4">
          <div class="card my-5">
            <header class="card-header">Filtre temps de Connexion</header>
            <div class="card-body">
              <form class="">
                <!-- societe -->
                <div role="group" class="form-group">
                  <label for="">Société</label>
                  <div class="input-group">
                    <multiselect
                      v-model="societeValueConnexion"
                      :options="societeOptions"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      label="name"
                      track-by="name"
                      :preselect-first="true"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- ./societe -->
                <!-- user -->
                <div role="group" class="form-group">
                  <label for="">Utilisateurs</label>
                  <div class="input-group">
                    <multiselect
                      v-model="userValueConnexion"
                      :options="userOptionsConnexion"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      label="name"
                      track-by="name"
                      :preselect-first="true"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- user -->
                <div role="group" class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Date de début</span>
                    </div>
                    <b-form-datepicker
                      id="date-deb-connexion"
                      v-model="dateDebutConnexion"
                      :max="dateMax"
                      :hide-header="true"
                      calendar-width="300px"
                      :today-button="false"
                      :date-format-options="{
                        day: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                      }"
                      @input="handleChangeDateDeb"
                    >
                    </b-form-datepicker>
                  </div>
                </div>
                <div role="group" class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Date de fin</span>
                    </div>
                    <b-form-datepicker
                      id="date-fin-connexion"
                      v-model="dateFinConnexion"
                      :min="dateMinFin"
                      :max="dateMax"
                      :hide-header="true"
                      calendar-width="300px"
                      :today-button="false"
                      :date-format-options="{
                        day: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                      }"
                    >
                    </b-form-datepicker>
                  </div>
                </div>
                <div class="form-actions text-right">
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    @click="resetFilterConnexion"
                  >
                    Effacer filtre
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="handleSubmitFilterConnexion"
                  >
                    Filtrer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- ./filtre -->
        <!-- filtre resultat-->
        <div class="col-8">
          <div class="my-5">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" role="tab">
                Statistique temps d' utilisation par connexion
              </b-card-header>
              <b-card-body>
                <div v-for="societe in listItemsConnexion" :key="societe.id">
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button
                        block
                        class="d-flex justify-content-start"
                        v-b-toggle="'societe_connexion_' + societe.id"
                        variant="primary"
                        >{{ societe.nom }}
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      :id="'societe_connexion_' + societe.id"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-table
                          striped
                          hover
                          :items="societe.connexions"
                        ></b-table>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </b-card-body>
            </b-card>
          </div>
          <b-card no-body class="mb-1">
              <b-card-header header-tag="header" role="tab">
                Statistique temps d' utilisation par module
              </b-card-header>
              <b-card-body>
                <div v-for="moduleItem in listItemsConnexionModule" :key="moduleItem.name">
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button
                        block
                        class="d-flex justify-content-start"
                        v-b-toggle="'societe_module_' + moduleItem.name"
                        variant="primary"
                        >{{ moduleItem.name }}
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      :id="'societe_module_' + moduleItem.name"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-table
                          striped
                          hover
                          :items="moduleItem.utilisateurs"
                        ></b-table>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </b-card-body>
            </b-card>
        </div>
        <!-- ./filtre resultat-->
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    Multiselect
  },
  data () {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const maxDate = new Date(today)
    return {
      societeValue: [],
      societeValueConnexion: [],
      societeOptions: [],
      userValue: [],
      userValueConnexion: [],
      userOptions: [],
      userOptionsConnexion: [],
      dateDebut: today,
      dateDebutConnexion: today,
      dateFin: today,
      dateFinConnexion: today,
      dateMax: maxDate,
      dateMinFin: today,
      listItems: [],
      listItemsConnexion: [],
      noResult: false,
      noResultCreatedProject: false,
      listItemsConnexionModule: []
    }
  },
  watch: {
    societeValue (val) {
      this.userOptions = []
      val.forEach(async (societe) => {
        let userList = await this.getUsersByClientId(societe.id)
        userList = userList.map(user => {
          return {
            name: user.nom,
            id: user.id
          }
        })
        this.userOptions = [...this.userOptions, ...userList]
      })
    },
    societeValueConnexion (val) {
      this.userOptionsConnexion = []
      val.forEach(async (societe) => {
        let userList = await this.getUsersByClientId(societe.id)
        userList = userList.map(user => {
          return {
            name: user.nom,
            id: user.id
          }
        })
        this.userOptionsConnexion = [...this.userOptionsConnexion, ...userList]
      })
    }
  },
  async mounted () {
    await this.getClients()
    this.societeOptions = this.societeLists.map(societe => {
      return {
        name: societe.nom,
        id: societe.id
      }
    })

    await this.getConnectedInvite()
    this.resetFilter()
    this.resetFilterConnexion()
  },
  computed: {
    ...mapGetters(['societeLists', 'statInfoList', 'usersConnected', 'usersConnectedCount', 'statCreatedProjectList', 'statTempsConnexionList', 'statTempsModuleList'])
  },
  methods: {
    ...mapActions(['getClients', 'getUsersByClientId', 'getStatInfoList', 'getConnectedInvite', 'getStatCreatedProject', 'getStatTempsConnexion', 'getStatTempsConnexionModule']),
    handleChangeDateDeb () {
      this.dateMinFin = this.dateDebut
    },
    async handleSubmitFilter () {
      const payload = {
        societes: this.societeValue.length > 0 ? this.societeValue.map(soc => soc.id) : [],
        utilisateurs: this.userValue.length > 0 ? this.userValue.map(soc => soc.id) : [],
        dateDebut: this.formatDate(this.dateDebut),
        dateFin: this.formatDate(this.dateFin)
      }
      await this.getStatCreatedProject(payload)
      if (this.statCreatedProjectList.length <= 0) {
        this.noResultCreatedProject = true
      }

      await this.getStatInfoList(payload)
      this.listItems = this.statInfoList
      if (this.listItems.length > 0) return
      this.noResult = true
    },
    async handleSubmitFilterConnexion () {
      const payload = {
        societes: this.societeValueConnexion.length > 0 ? this.societeValueConnexion.map(soc => soc.id) : [],
        utilisateurs: this.userValueConnexion.length > 0 ? this.userValueConnexion.map(soc => soc.id) : [],
        dateDebut: this.formatDate(this.dateDebutConnexion),
        dateFin: this.formatDate(this.dateFinConnexion)
      }

      await this.getStatTempsConnexion(payload)
      this.listItemsConnexion = this.statTempsConnexionList
      await this.getStatTempsConnexionModule(payload)
      this.listItemsConnexionModule = this.statTempsModuleList
    },
    formatDate (date) {
      date = new Date(date)
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var day = ('0' + date.getDate()).slice(-2)
      return year + '-' + month + '-' + day
    },
    async resetFilter () {
      this.noResultCreatedProject = false
      this.noResult = false
      this.societeValue = []
      this.userValue = []
      const payload = {
        societes: [],
        utilisateurs: [],
        dateDebut: null,
        dateFin: null
      }
      await this.getStatInfoList(payload)
      await this.getStatCreatedProject(payload)
      this.listItems = this.statInfoList
    },
    async resetFilterConnexion () {
      this.societeValueConnexion = []
      this.userValueConnexion = []
      const payload = {
        societes: [],
        utilisateurs: [],
        dateDebut: null,
        dateFin: null
      }
      await this.getStatTempsConnexion(payload)
      this.listItemsConnexion = this.statTempsConnexionList
      await this.getStatTempsConnexionModule(payload)
      this.listItemsConnexionModule = this.statTempsModuleList
    }
  }
}
</script>

<style lang="scss">
.statistique-page {
  margin-top: 50px;
  .card-header {
    font-family: "Open Sans";
    font-weight: 700;
  }
  table {
    font-family: "Open Sans";
    thead {
      font-weight: 700;
      th {
        font-size: 12px;
        &:last-child {
          text-align: center;
        }
      }
    }
    tbody {
      tr {
        td {
          font-size: 12px;
          &:last-child {
            font-weight: 700;
            color: #236aa3;
            font-size: 14px;
            text-align: center;
          }
        }
      }
    }
  }
}
#list-user {
  ul {
    padding-left: 0;
    margin-bottom: 0;
    li {
      font-family: "Open Sans";
      font-size: 12px;
      font-weight: 600;
    }
  }
}
.result-wrapper {
  button {
    box-shadow: none !important;
  }
  .table {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/statistiques/index.vue